import { useMutation, useQuery } from "react-query";
import { EvaluationFormService } from "./evaluationFormService";

export const useCreateEvaluationForm = () =>
  useMutation({
    mutationFn: EvaluationFormService.create,
  });

export const useEvaluationForms = () =>
  useQuery({
    queryKey: ["evaluation-forms"],
    queryFn: EvaluationFormService.getAll,
    select: (data) => (Array.isArray(data) ? data : []), 
  });

export const useEvaluationFormById = (id) =>
  useQuery({
    queryKey: ["evaluation-form", id],
    queryFn: () => EvaluationFormService.getById(id),
    enabled: !!id,
  });

export const useEvaluationFormByYear = (year) =>
  useQuery({
    queryKey: ["evaluation-form-year", year],
    queryFn: () => EvaluationFormService.getByYear(year),
    enabled: !!year,
  });

export const useEvaluationFormWithSections = (id) =>
  useQuery({
    queryKey: ["evaluation-form-sections", id],
    queryFn: () => EvaluationFormService.getById(id),
    enabled: !!id,
  });
export const useUpdateEvaluationForm = () =>
  useMutation({
    mutationFn: ({ id, ...data }) => EvaluationFormService.update(id, data),
  });
export const useDeleteEvaluationForm = () =>
  useMutation({
    mutationFn: (id) => EvaluationFormService.remove(id),
  });
export const useSubmissionsByForm = (formId) => {
  return useQuery(
    ["form-submissions", formId],
    () => EvaluationFormService.getAllSubmissions(formId),
    {
      enabled: !!formId,
    }
  );
};
